import React from 'react';

import { Box, LinearProgress, Stack, Typography } from '@mui/material';

const Step: React.FC<{ active?: boolean }> = ({ active = false }) => {
  const color = React.useMemo(() => (active ? 'primary' : 'secondary'), [active]);

  return (
    <Box flex={1}>
      <LinearProgress
        variant='determinate'
        value={100}
        color={color}
        sx={{
          borderRadius: '10px',
          height: '10px',
        }}
      />
    </Box>
  );
};

type Props = {
  numberOfSteps: number;
  activeStep: number;
};

export const FlowStepper: React.FC<Props> = ({ numberOfSteps, activeStep }) => {
  return (
    <Stack direction='row' spacing={1} alignItems={'center'}>
      <Typography fontWeight={600} fontSize={'14px'}>
        {activeStep + 1}/{numberOfSteps}
      </Typography>
      {Array.from({ length: numberOfSteps }, (_, i) => (
        <Step key={i} active={activeStep >= i} />
      ))}
    </Stack>
  );
};
